export const RequestCriticalReason = {
  Overdue: 'overdue',
  Stalled: 'stalled',
  WithoutProvider: 'without_provider',
}

export const REQUEST_CRITICAL_REASON_TEXT_KEY = {
  [RequestCriticalReason.Overdue]: 'RequestTable.CriticalReasonOverdueKey',
  [RequestCriticalReason.Stalled]: 'RequestTable.CriticalReasonStaleKey',
  [RequestCriticalReason.WithoutProvider]:
    'RequestTable.CriticalReasonNoProviderKey',
}
